import HttpClient from '@/utility/http-client';

export default {
    getList(page: number = 1, rowsPerPage: number = 10, status: string = 'all', search: string = '', officialFilterParams: any = {}) {
        let url = `/api/quotation/?page=${page}&rowsPerPage=${rowsPerPage}`;
        if (status && status !== 'all') {
            url += `&status=${encodeURIComponent(status)}`;
        }
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        if (officialFilterParams && typeof officialFilterParams === 'object') {
            for (const key of Object.keys(officialFilterParams)) {
                const val = officialFilterParams[key];
                if (val === undefined || val === null || val === '') continue;
                if (Array.isArray(val)) {
                    val.forEach((item: any) => {
                        url += `&${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`;
                    });
                } else {
                    url += `&${encodeURIComponent(key)}=${encodeURIComponent(String(val))}`;
                }
            }
        }
        return HttpClient.instance().get(url);
    },

    getById(id: number | string) {
        const url = `/api/quotation/${id}`;
        return HttpClient.instance().get(url);
    },

    getStatusCounts() {
        const url = `/api/quotation/status_counts/`;
        return HttpClient.instance().get(url);
    },

    getComments(quotationId: number | string) {
        const url = `/api/quotation/${quotationId}/comments/`;
        return HttpClient.instance().get(url);
    },

    addComment(quotationId: number | string, content: string, parent?: number, extra?: any) {
        const url = `/api/quotation/${quotationId}/comments/`;
        return HttpClient.instance().post(url, {
            content,
            parent,
            extra
        });
    },

    createConsignment(dataRequest: any) {
        const url = `/api/quotation/create_consignment/`;
        return HttpClient.instance().post(url, dataRequest);
    },

    getPorts() {
        const url = `/api/quotation/ports/`;
        return HttpClient.instance().get(url);
    },

    updatePorts(id: number | string, data: { port_departure?: string; port_arrival?: string }) {
        const url = `/api/quotation/${id}/update_ports/`;
        return HttpClient.instance().post(url, data);
    },

    updateWarehouses(id: number | string, data: {
        warehouse_cn?: string;
        legacy_china_store_id?: number | null;
        warehouse_vn?: string;
        legacy_receive_place_id?: number | null;
    }) {
        const url = `/api/quotation/${id}/update_warehouses/`;
        return HttpClient.instance().post(url, data);
    },

    importGoods(id: number | string, file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return HttpClient.instance().post(`/api/quotation/${id}/import_items_excel/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    getLinkedOrders(id: number | string) {
        const url = `/api/quotation/${id}/linked_orders/`;
        return HttpClient.instance().get(url);
    },

    getLinkedTth(id: number | string) {
        const url = `/api/quotation/${id}/linked_tth/`;
        return HttpClient.instance().get(url);
    },

    uploadImage(file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return HttpClient.instance().post('/api/quotation/upload_image/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    getOfficialTrackings(page: number = 1, rowsPerPage: number = 15, status: string = '', search: string = '') {
        let url = `/api/official_tracking/?page=${page}&rowsPerPage=${rowsPerPage}`;
        if (status) {
            url += `&status=${encodeURIComponent(status)}`;
        }
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        return HttpClient.instance().get(url);
    },

    getComplainByQuotationId(quotationId: number | string) {
        const url = `/api/quotation/${quotationId}/complain/`;
        return HttpClient.instance().get(url);
    },
    getComplaintsByQuotationId(quotationId: number | string) {
        const url = `/api/quotation/complaints/?order_id=${quotationId}&rowsPerPage=100`;
        return HttpClient.instance().get(url);
    },
    getComplaintsList(page: number = 1, rowsPerPage: number = 10, status: string = 'all', search: string = '') {
        let url = `/api/quotation/complaints/?page=${page}&rowsPerPage=${rowsPerPage}`;
        if (status && status !== 'all') {
            url += `&status=${encodeURIComponent(status)}`;
        }
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        return HttpClient.instance().get(url);
    },

    getComplaintStatusCounts() {
        const url = `/api/quotation/complaints/status_counts/`;
        return HttpClient.instance().get(url);
    },

    createComplaint(dataRequest: any) {
        const url = `/api/quotation/complaints/`;
        return HttpClient.instance().post(url, dataRequest);
    },

    updateComplaint(complainId: number | string, dataRequest: any) {
        const url = `/api/complain/${complainId}`;
        return HttpClient.instance().post(url, dataRequest);
    },
};